import { REPORT_IDS } from 'features/shared/constants/reportIds';
import InfoIcon from '@material-ui/icons/Info';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RMSButton } from '../../../shared/components/buttons';
import { CommonDataGrid } from 'features/shared/components/table';
import { RMSConfirmationDialog } from '../../../shared/components/dialog';
import useConfirmDialog from '../../../shared/utility/useConfirmDialog';
import { executeApiAction } from '../../../shared/utility/apiHelper';
import ZoneSopDialog from './ZoneSopDialog';
import AddIcon from '@material-ui/icons/Add';
import { getZoneSops, deleteZoneSop } from '../../services/sopService';
import { showReport } from 'reducers/PersonDialogsReducer';
import { checkReportPermission } from 'utils/functions';
import { SOP_GRID_COLUMNS } from '../../constants/personSopsTabConstants';

const ZoneSopsTab = ({ record, permissions, onSopsChanged }) => {
  const dispatch = useDispatch();
  const dataUpdate = useSelector((state) => state.dataUpdate);
  const [rows, setRows] = useState([]);
  const [formOpen, setFormOpen] = useState(false);
  const [editingSop, setEditingSop] = useState(null);
  const [loading, setLoading] = useState(false);
  const { confirmState, requestConfirm, handleYes, handleNo } = useConfirmDialog();
  const load = useCallback(
    () =>
      executeApiAction({
        dispatch,
        setLoading,
        action: () => getZoneSops(record.IntCode),
        onSuccess: (result) => {
          const links = result?.data || result || [];
          setRows(links);
          onSopsChanged(links.length);
        },
      }),
    [dispatch, record.IntCode, onSopsChanged]
  );

  useEffect(() => {
    load();
  }, [load]);

  useEffect(() => {
    if (dataUpdate?.type === 'update-sop') load();
  }, [dataUpdate, load]);

  const remove = (row) =>
    requestConfirm(
      'Remove this SOP from the zone?',
      () =>
        executeApiAction({
          dispatch,
          setLoading,
          action: () =>
            deleteZoneSop({
              ptsParentID: record.IntCode,
              ParentType: 'Zone',
              ptsSOPID: row.ptsSOPID,
            }),
          onSuccess: () => load(),
        }),
      'Remove SOP'
    );

  return (
    <div className="zone-grid-tab">
      <div className="zone-grid-tab__toolbar">
        <RMSButton
          label="Add SOP"
          prefixIcon={<AddIcon />}
          onClick={() => {
            setEditingSop(null);
            setFormOpen(true);
          }}
          disabled={!permissions.Edit || loading}
        />
      </div>
      <CommonDataGrid
        rows={rows}
        columns={SOP_GRID_COLUMNS}
        getRowId={(row) => row.ptsSOPID}
        loading={loading}
        actions={{
          edit: {
            visible: true,
            disabled: !permissions.Edit,
            onClick: (row) => {
              setEditingSop(row);
              setFormOpen(true);
            },
          },
          delete: { visible: true, disabled: !permissions.Edit, onClick: remove },
          custom: [
            {
              icon: <InfoIcon />,
              tooltip: 'View Details',
              onClick: (row) => {
                if (checkReportPermission(REPORT_IDS.SOP_DETAILS))
                  dispatch(
                    showReport({
                      id: REPORT_IDS.SOP_DETAILS,
                      data: { ptsSOPID: row.ptsSOPID },
                      title: 'SOP Details',
                    })
                  );
              },
            },
          ],
        }}
      />
      {formOpen && (
        <ZoneSopDialog
          zoneId={record.IntCode}
          sopLink={editingSop}
          canEdit={permissions.Edit}
          existingSopIds={rows.map((row) => row.ptsSOPID)}
          onClose={() => setFormOpen(false)}
          onSaved={() => {
            setFormOpen(false);
            load();
          }}
        />
      )}
      {confirmState.open && (
        <RMSConfirmationDialog
          open
          title={confirmState.title}
          message={confirmState.message}
          onYes={handleYes}
          onNo={handleNo}
        />
      )}
    </div>
  );
};
export default ZoneSopsTab;
